import { SetItem } from "@/models/SetItem";

export class ImageGalleryDialogItemHelper {
  public getItemColoreName(item: SetItem): string {
    return item.product &&
      item.product.color &&
      typeof item.product.color !== 'string' &&
      item.product.color.name
        ? item.product.color.name
        : '';
  }

  public getItemImageUrl(item: SetItem): string {
    return item.product && item.product.url_large
      ? item.product.url_large
      : '';
  }

  public getItemName(item: SetItem): string {
    return item.product && item.product.product_name
      ? item.product.product_name
      : '';
  }

  public getItemSizeName(item: SetItem): string {
    return item.product &&
      item.product.size &&
      typeof item.product.size !== 'string' &&
      item.product.size.name
        ? item.product.size.name
        : '';
  }

  public getItemSupplierName(item: SetItem): string {
    return item.product &&
      item.product.supplier &&
      typeof item.product.supplier !== 'string' &&
      item.product.supplier.name
        ? item.product.supplier.name
        : '';
  }
}
